module.exports = global["Tether"] = require("-!/Users/manuelcoiai/Repositories/zucchelli/zucchelli/_dev/node_modules/babel-loader/index.js!./tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
// module id = 28
// module chunks = 0